"use strict";

module.exports = {
  'name': 'LN2',
  'category': 'Constants',
  'syntax': ['LN2'],
  'description': 'Returns the natural logarithm of 2, approximately equal to 0.693',
  'examples': ['LN2', 'log(2)'],
  'seealso': []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/constants/LN2.js
// module id = 787
// module chunks = 0